export const FETCH_FAQ_REQUEST = 'FAQ/FETCH_FAQ_REQUEST';
export const FETCH_FAQ_FAILURE = 'FAQ/FETCH_FAQ_FAILURE';
export const FETCH_FAQ_SUCCESS = 'FAQ/FETCH_FAQ_SUCCESS';
